import { type TooltipLabelProps } from '~/components/component-library/Tooltip/types'

export const TooltipLabel = ({ title, detail }: TooltipLabelProps) => (
  <div className="flex max-w-56 flex-col gap-0.5 text-left leading-tight">
    <span className="break-words font-medium">{title}</span>
    {detail && (
      <div className="flex flex-col gap-0.5 text-balance break-words text-secondary">
        {detail}
      </div>
    )}
  </div>
)
